// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription-SideBar-Container {
    display: flex;
    flex-direction: column;
    margin-top: 135px;
  }
  .SubscriptionSidebar01 {
    color: #061522;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    height: 56px;
    display: flex;
    align-items: center;
    padding: 10px 32px;
    cursor: pointer;
  }
  .SubscriptionPolicy-Container {
    display: flex;
    max-width: 1440px;
    margin: 0 auto;
  }
  .SubscriptionPolicy-SideContainer {
    width: 268px;
    height: auto;
    background: #fff;
    overflow: hidden;
    transition: all 0.1s linear;
  }
  .Subscription-Content-Container {
    flex-grow: 1;
    width: 70%;
  }
  .Subscription-ContentContainer {
    height: calc(100vh - 130px);
    overflow-y: auto;
    padding: 0px 250px 0px 50px;
  }
  .SubscriptionPolicy-Footer {
    max-width: 1440px;
    margin: 0 auto;
  }
  .activeSubscription {
    border-radius: 9px;
    background: #f9fafa;
    cursor: pointer;
    margin: 0px 16px;
    padding: 0px 16px;
    color: #061522;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
  }
  .Subscription-policy-heading {
    margin-top: 45px;
    color: #405261;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 112.5% */
  }
  .Subscription-policy-heading-content {
    color: #061522;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px; /* 141.667% */
    margin-top: 34px;
    margin-bottom: 12px;
  }
  .Subscription-policy-content-text {
    color: #405261;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
  }
  .Subscription-Line{
      background: #E5E9EC;
      height: 1px;
      width: 100%;
      margin: 44px 0px;
  }
  .Subscription-bulletPoint{
      margin: 20px 0px;
      list-style-type: square;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Subscription/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;EAClC;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;EAChC;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;EAClC;EACA;MACI,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,gBAAgB;EACpB;EACA;MACI,gBAAgB;MAChB,uBAAuB;EAC3B","sourcesContent":[".Subscription-SideBar-Container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 135px;\n  }\n  .SubscriptionSidebar01 {\n    color: #061522;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 128.571% */\n    height: 56px;\n    display: flex;\n    align-items: center;\n    padding: 10px 32px;\n    cursor: pointer;\n  }\n  .SubscriptionPolicy-Container {\n    display: flex;\n    max-width: 1440px;\n    margin: 0 auto;\n  }\n  .SubscriptionPolicy-SideContainer {\n    width: 268px;\n    height: auto;\n    background: #fff;\n    overflow: hidden;\n    transition: all 0.1s linear;\n  }\n  .Subscription-Content-Container {\n    flex-grow: 1;\n    width: 70%;\n  }\n  .Subscription-ContentContainer {\n    height: calc(100vh - 130px);\n    overflow-y: auto;\n    padding: 0px 250px 0px 50px;\n  }\n  .SubscriptionPolicy-Footer {\n    max-width: 1440px;\n    margin: 0 auto;\n  }\n  .activeSubscription {\n    border-radius: 9px;\n    background: #f9fafa;\n    cursor: pointer;\n    margin: 0px 16px;\n    padding: 0px 16px;\n    color: #061522;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 128.571% */\n  }\n  .Subscription-policy-heading {\n    margin-top: 45px;\n    color: #405261;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 112.5% */\n  }\n  .Subscription-policy-heading-content {\n    color: #061522;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 34px; /* 141.667% */\n    margin-top: 34px;\n    margin-bottom: 12px;\n  }\n  .Subscription-policy-content-text {\n    color: #405261;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 171.429% */\n  }\n  .Subscription-Line{\n      background: #E5E9EC;\n      height: 1px;\n      width: 100%;\n      margin: 44px 0px;\n  }\n  .Subscription-bulletPoint{\n      margin: 20px 0px;\n      list-style-type: square;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
